import React, { FC } from 'react';

type AppUpsellCtaProps = {
  storeUrl: string;
  ctaLabel: string;
  onClick: () => void;
  dataCy: string;
};

/**
 * Store-link CTA shared by the upsell modal and banner. A real anchor —
 * nesting the Button atom inside an <a> would put interactive content
 * inside a link, which is invalid HTML — styled to match Button's
 * primary variant.
 */
const AppUpsellCta: FC<AppUpsellCtaProps> = ({
  storeUrl,
  ctaLabel,
  onClick,
  dataCy
}) => (
  <a
    href={storeUrl}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    data-cy={dataCy}
    className="inline-flex outline-0 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 justify-center text-center rounded-lg transition-colors font-open-sans font-bold text-base border-2 border-transparent py-[7px] px-3 text-white bg-primary-600 hover:bg-primary-800 active:bg-neutral-800 cursor-pointer"
  >
    {ctaLabel}
  </a>
);

export default AppUpsellCta;
